module.exports = __webpack_public_path__ + "static/img/4fb2f1b4db3bb06089d1eff3b504e91a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_adv3.jpg
// module id = 4UHb
// module chunks = 1